import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ColorForm from '../../../../components/masters/styles/color/ColorForm';
import ColorTable from '../../../../components/masters/styles/color/ColorTable';
import { fetchColors, addColor, updateColor, deleteColor, setColorEdit, clearColorEdit } from '../../../../redux/actions/masters/styles/color/colorAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .color-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .color-form, .color-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const ColorPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingColor } = useSelector(state => state.color || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchColors());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearColorEdit());
  };

  const handleSubmit = async (form) => {
    if (editingColor && editingColor.id) {
      await dispatch(updateColor(editingColor.id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addColor(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (color) => {
    dispatch(setColorEdit(color));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteColor(id));
  };

  const handleCancel = () => {
    dispatch(clearColorEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      c => c.color_code === code && (!excludeId || c.id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="color-flex">
        <div style={tableContainer} className="color-table">
          <ColorTable
            onNew={handleFormReset}
            colors={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="color-form">
          <ColorForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingColor={editingColor}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default ColorPage; 